import type { ProductUnsecuredLoanConfig } from '../../@types/context/product-unsecured-loan-config.types';

export const unsecuredLoansNoConfig: Omit<
  ProductUnsecuredLoanConfig,
  'fields'
> = {
  rates: {
    low: 4.9,
    mid: 11.9,
    high: 19.9,
    startup_fee: 950,
    monthly_fee: 30,
  },
  config: {
    amount: {
      min: 10_000,
      max: 800_000,
      default: 150_000,
      step: 5_000,
    },
    duration: {
      min: 1,
      max: 20,
      default: 5,
      step: 1,
    },
  },
};
